// client/src/hooks/TimerContext.js
import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';

const TimerContext = createContext();

export function useTimer() {
  return useContext(TimerContext);
}

export const TimerProvider = ({ children }) => {
  const [timerId, setTimerId] = useState(null);
  const [remainingTime, setRemainingTime] = useState(0);
  const [isTimerFinished, setIsTimerFinished] = useState(false); // New state flag

  const startActivityTimer = useCallback((durationInSeconds, onTimerEnd) => {
    // Clear any existing timer and reset status
    if (timerId) {
      clearInterval(timerId);
    }
    setIsTimerFinished(false); // Reset finished status on new start
    setRemainingTime(durationInSeconds);
    console.log(`Started timer for ${durationInSeconds} seconds`);

    const id = setInterval(() => {
      setRemainingTime(prevTime => {
        const newTime = prevTime - 1;
        if (newTime <= 0) {
          clearInterval(id);
          setTimerId(null);
          setIsTimerFinished(true); // Set flag when timer ends naturally
          // Optional: Keep onTimerEnd if needed for other purposes
          // if (onTimerEnd) {
          //  onTimerEnd();
          // }
          return 0;
        }
        return newTime;
      });
    }, 1000);
    setTimerId(id);
  }, [timerId]); // timerId dependency is correct here for cleanup logic

  // Function to manually stop the timer
  const stopActivityTimer = useCallback(() => {
    if (timerId) {
      clearInterval(timerId);
      setTimerId(null);
      setRemainingTime(0);
      // Optionally set finished flag true on manual stop? Depends on desired logic.
      // setIsTimerFinished(true);
      console.log("Timer stopped manually");
    }
  }, [timerId]);

  // Function to allow components to reset the finished status (e.g., after handling it)
  const resetTimerFinishedStatus = useCallback(() => {
    setIsTimerFinished(false);
  }, []);

  // Clear timer on unmount
  useEffect(() => {
    return () => {
      if (timerId) {
        clearInterval(timerId);
      }
    };
  }, [timerId]);


  return (
    <TimerContext.Provider value={{ remainingTime, isTimerFinished, startActivityTimer, stopActivityTimer, resetTimerFinishedStatus }}>
      {children}
    </TimerContext.Provider>
  );
};